const FREQUENCY_LABELS: Record<string, string> = {
  MONTHLY: 'Monthly',
  QUARTERLY: 'Quarterly',
  HALF_YEARLY: 'Half yearly',
  YEARLY: 'Yearly',
};

export const DVLA_TIMEZONE_OPTIONS = [
  'Europe/London',
  'Europe/Dublin',
  'Europe/Paris',
  'Europe/Berlin',
  'Europe/Amsterdam',
  'UTC',
  'America/New_York',
  'America/Chicago',
  'America/Los_Angeles',
  'Australia/Sydney',
];

export function formatDayOfMonthLabel(dayOfMonth: number): string {
  if (dayOfMonth === 0) return 'the last day';
  const suffix =
    dayOfMonth >= 11 && dayOfMonth <= 13
      ? 'th'
      : ({ 1: 'st', 2: 'nd', 3: 'rd' } as Record<number, string>)[dayOfMonth % 10] || 'th';
  return `the ${dayOfMonth}${suffix}`;
}

export function formatScheduleTimeForInput(time: string | null | undefined): string {
  if (!time) return '06:00';
  const str = String(time);
  return str.length >= 5 ? str.slice(0, 5) : '06:00';
}

export function formatScheduleSummary(options: {
  frequency: string | null;
  dayOfMonth: number;
  time: string;
  timezone: string;
  nextCheckDate?: string | null;
}): string {
  const { frequency, dayOfMonth, time, timezone, nextCheckDate } = options;
  if (!frequency) return 'Select a frequency to enable automated checks.';

  const freq = FREQUENCY_LABELS[frequency] || frequency;
  const dayLabel = formatDayOfMonthLabel(dayOfMonth);
  const timeLabel = formatScheduleTimeForInput(time);
  const tzLabel = timezone.replace(/_/g, ' ');

  let intervalPhrase: string;
  switch (frequency) {
    case 'MONTHLY':
      intervalPhrase = `on ${dayLabel} of every month`;
      break;
    case 'QUARTERLY':
      intervalPhrase = `on ${dayLabel} every 3 months`;
      break;
    case 'HALF_YEARLY':
      intervalPhrase = `on ${dayLabel} every 6 months`;
      break;
    case 'YEARLY':
      intervalPhrase = `on ${dayLabel} every year`;
      break;
    default:
      intervalPhrase = `on ${dayLabel}`;
  }

  const nextLine = nextCheckDate
    ? ` Next scheduled run: ${new Date(nextCheckDate).toLocaleDateString('en-GB', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      })} at ${timeLabel} (${tzLabel}).`
    : '';

  return `${freq} — ${intervalPhrase} at ${timeLabel} (${tzLabel}).${nextLine}`;
}

export const DVLA_DAY_OF_MONTH_OPTIONS: { value: number; label: string }[] = [
  ...Array.from({ length: 31 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}${i + 1 >= 11 && i + 1 <= 13 ? 'th' : ({ 0: 'th', 1: 'st', 2: 'nd', 3: 'rd' } as Record<number, string>)[(i + 1) % 10] || 'th'}`,
  })),
  { value: 0, label: 'Last day of month' },
];
